import { Component, ElementRef, OnInit } from '@angular/core';
import { base64ToFile, ImageCroppedEvent } from 'ngx-image-cropper';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import { CroppedImage } from 'src/app/_models/Common/croped-image';
import { CompressImageService } from 'src/app/_services/compress-image.service';
import 'hammerjs';

@Component({
  selector: 'app-crop-and-compress-image-dialog',
  templateUrl: './crop-and-compress-image-dialog.component.html',
  styleUrls: ['./crop-and-compress-image-dialog.component.scss']
})
export class CropAndCompressImageDialogComponent implements OnInit {
  pictureFormat: Array<string>;
  pictureIsWrongFormat: boolean = false;
  // maxSize: number = 3000000;  //3 MB = 3000000 Bytes (in decimal)
  imageChangedEvent: any = '';
  croppedImage: any = '';
  showCropper = false;
  imagePath: string | ArrayBuffer = './assets/images/logo/Event-Cover-Placeholder.png';
  imageName: string;

  compressedImage: File;
  canSave: boolean = false;

  constructor(
    private compressImage: CompressImageService,
    private openFile: ElementRef,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig, 
    ) {
    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];
    if (this.config.data != undefined && this.config.data.imagePath) {
      this.imagePath = this.config.data.imagePath;
    }
  }

  ngOnInit(): void {}

  save() {
    const result = new CroppedImage();
    result.imageFile = this.compressedImage;
    result.imagePath = this.imagePath;
    if(result.imageFile != undefined){
      this.ref.close(result);
    }
  }
  cancel(){
    this.ref.close();
  }
  onSelectFile(event: any) {
    this.imageChangedEvent = event;
    this.pictureIsWrongFormat = false;
    if (event.target.files && event.target.files[0]) {
      
      if (!this.pictureFormat.includes(event.target.files[0].type)) {
        this.pictureIsWrongFormat = true;
        this.showCropper = false;
      } else {
        this.imageName = event.target.files[0].name;
        this.showCropper = true;
      }
    }
  }

  openAddImage() {
    var element = this.openFile.nativeElement.querySelector(".open-file");
    element.click();
  }
  
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    let myBlob = base64ToFile(this.croppedImage)
    const myFile = new File([myBlob], this.imageName, {
      type: myBlob.type,
    });
    var reader = new FileReader();
    reader.readAsDataURL(myFile);// read file as data url
    this.compressImage.compress(myFile)
      .pipe(take(1))
      .subscribe(compressedImage => {
        this.compressedImage = compressedImage;
      })
    reader.onload = (item) => { // called once readAsDataURL is completed
      if (item.target?.result) {
        this.imagePath = item.target?.result;
      }
    }
  }
  imageLoaded() {
    // show cropper
    this.canSave = true;
  }
  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message mozam popup message
    // console.log("Nevaliden format");
  }

}
